export { default as CompetitionDetailOverlay } from './CompetitionDetailOverlay';
export type { CompetitionDetailOverlayProps } from './CompetitionDetailOverlay';
